var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.611,
    height: 25.611,
    viewBox: "0 0 25.611 25.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.084,
    y1: 0.916,
    x2: 0.916,
    y2: 0.084,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d800b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram_3_",
    "data-name": "instagram (3)",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_30594",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 30594",
    d: "M25.534,7.526a9.4,9.4,0,0,0-.6-3.108,6.276,6.276,0,0,0-1.477-2.268A6.278,6.278,0,0,0,21.194.672,9.4,9.4,0,0,0,18.085.077C16.72.015,16.283,0,12.806,0S8.891.015,7.526.077a9.4,9.4,0,0,0-3.108.6A6.276,6.276,0,0,0,2.149,2.149,6.277,6.277,0,0,0,.672,4.417,9.4,9.4,0,0,0,.077,7.526C.015,8.891,0,9.327,0,12.805s.015,3.914.077,5.28a9.4,9.4,0,0,0,.6,3.108,6.275,6.275,0,0,0,1.477,2.268,6.274,6.274,0,0,0,2.268,1.477,9.4,9.4,0,0,0,3.108.6c1.366.062,1.8.077,5.28.077s3.914-.015,5.28-.077a9.4,9.4,0,0,0,3.108-.6,6.547,6.547,0,0,0,3.745-3.745,9.4,9.4,0,0,0,.6-3.108c.062-1.366.077-1.8.077-5.28s-.015-3.914-.077-5.28ZM23.229,17.98a7.085,7.085,0,0,1-.441,2.378,4.241,4.241,0,0,1-2.43,2.43,7.085,7.085,0,0,1-2.378.441c-1.35.062-1.755.075-5.175.075s-3.825-.013-5.175-.075a7.088,7.088,0,0,1-2.378-.441,3.969,3.969,0,0,1-1.472-.958,3.967,3.967,0,0,1-.958-1.472,7.085,7.085,0,0,1-.441-2.378c-.062-1.35-.075-1.755-.075-5.174s.013-3.824.075-5.175a7.09,7.09,0,0,1,.441-2.378,3.97,3.97,0,0,1,.958-1.473,3.965,3.965,0,0,1,1.473-.958,7.084,7.084,0,0,1,2.378-.441c1.35-.062,1.755-.075,5.175-.075h0c3.419,0,3.824.013,5.175.075a7.086,7.086,0,0,1,2.378.441,3.971,3.971,0,0,1,1.472.958,3.965,3.965,0,0,1,.958,1.473,7.079,7.079,0,0,1,.441,2.378c.062,1.35.075,1.755.075,5.174S23.291,16.63,23.229,17.98Zm0,0",
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_30595",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 30595",
    d: "M131.115,124.539a6.576,6.576,0,1,0,6.576,6.576A6.576,6.576,0,0,0,131.115,124.539Zm0,10.844a4.269,4.269,0,1,1,4.269-4.269A4.269,4.269,0,0,1,131.115,135.383Zm0,0",
    transform: "translate(-118.309 -118.31)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_30596",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 30596",
    d: "M365,90.162a1.537,1.537,0,1,1-1.537-1.537A1.537,1.537,0,0,1,365,90.162Zm0,0",
    transform: "translate(-343.824 -84.192)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f33c2fb92e2d06314a995cda6cba81a9.svg";
export { ForwardRef as ReactComponent };